export const prefixWithOn = text => `on${text.charAt(0).toUpperCase() + text.slice(1)}`;

export const removeGivenTextFromString = (string, givenText) => (string ? string.replace(givenText, '') : null);

export const cutInLines = (string, maxLengthByLine) => {
  if (!string) {
    return '';
  }

  return string.split(' ').reduce((acc, part) => {
    if (!acc.length) {
      return [part];
    }

    const currentLineLength = acc[acc.length - 1].length;
    if (currentLineLength + part.length < maxLengthByLine) {
      acc[acc.length - 1] = `${acc[acc.length - 1]} ${part}`;
    } else {
      acc[acc.length] = part;
    }

    return acc;
  }, []);
};

export const ucfirst = str => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
